import React from "react";
import {
  RadioGroup as ChakraRadioGroup,
  RadioGroupProps as ChakraRadioGroupProps,
  Stack,
  StackProps
} from "@chakra-ui/react";
import { generateId, useField } from "duck";
import { Types } from "../../duck";
import InputLayout from "../input-layout";

interface RadioGroupProps
  extends Omit<ChakraRadioGroupProps, "name">,
    Types.BaseInputProps {
  stackProps?: StackProps;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  label,
  labelHidden = false,
  inputLayoutProps,
  children,
  stackProps,
  ...rest
}) => {
  const labelId = React.useMemo(() => name || generateId(), [name]);

  const { onChange, value, error } = useField(name);

  return (
    <InputLayout
      id={labelId}
      label={label}
      labelHidden={labelHidden}
      errorMessage={error}
      {...inputLayoutProps}
      input={
        <ChakraRadioGroup
          name={labelId}
          onChange={onChange}
          value={value === null ? [] : value}
          {...rest}
        >
          <Stack spacing={8} direction="row" {...stackProps}>
            {children}
          </Stack>
        </ChakraRadioGroup>
      }
    />
  );
};

export default RadioGroup;
